<template>
  <div class="native-layout">
    
    <div class="fixed-header">
    </div>

    <div class="scroll-wrapper">
      
      <div class="content-body">
        
        <div class="py-6 px-4 space-y-2 text-white">
          <h2 class="text-xl font-bold">Hola, {{ user?.denominacion_comercial || 'Usuario' }}</h2>
          <div class="flex items-center gap-2 mt-1 flex-wrap">
            <span class="bg-yellow-500 px-2 py-1 rounded text-black text-xs font-bold">{{ user?.udn || 'Sucursal' }}</span>
            <span class="text-sm">Cliente: {{ user?.cliente || 'N/A' }}</span>
            <button @click="copyId" class="ml-auto text-white"><v-icon size="20" color="white">mdi-content-copy</v-icon></button>
          </div>
          <div class="text-sm opacity-90">
            <div><strong>Razón:</strong> {{ user?.razon_social || user?.razon || '-' }}</div>
            <div><strong>RFC:</strong> {{ user?.rfc || '-' }}</div>
          </div>
          <div class="flex justify-between items-end mt-4 border-t border-white/20 pt-2">
            <p class="text-sm text-white/80">{{ timeStore?.formattedDate }}</p>
            <p class="text-xl font-bold text-white">{{ timeStore?.formattedTime }}</p>
          </div>
        </div>

        <div class="flex justify-around bg-blue-900/50 py-2 mx-4 rounded-lg backdrop-blur-sm border border-white/10 mb-4">
          <div v-for="tab in tabs" :key="tab.name" @click="selectTab(tab.name)"
            class="flex-1 text-center cursor-pointer py-2 rounded-md transition-all"
            :class="selectedTab === tab.name ? 'text-yellow-400 scale-105' : 'text-white/70 hover:text-white'">
            <v-icon size="24" class="mb-1">{{ tab.icon }}</v-icon>
            <div class="text-xs font-medium">{{ tab.label }}</div>
          </div>
        </div>

        <div v-if="selectedTab === 'puntos'" class="mx-4 p-5 bg-blue-800 rounded-xl shadow-lg border border-blue-700 mb-4">
          <div class="flex justify-between items-center text-white mb-4">
            <span class="text-sm font-medium">Saldo de Puntos</span>
            <button class="text-xs bg-blue-900 px-3 py-1 rounded-full hover:bg-blue-950 transition" @click="obtenerNuevaData">
              {{ updatingPoints ? 'Actualizando...' : '🔄 Actualizar' }}
            </button>
          </div>
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-blue-200">Tienes acumulados:</p>
              <p class="text-4xl font-black text-white tracking-tight">{{ user?.mvCoins ? Math.floor(user.mvCoins) : '0' }}</p>
            </div>
            <img src="https://mvexpress.mx/images/mvsimple.png" class="w-16 h-16 drop-shadow-md" alt="mvcoins" />
          </div>
        </div>

        <div v-show="selectedTab === 'historial'">
          <HistorialPedidosView :isComponent="true" />
        </div>

        <div v-show="selectedTab === 'direcciones'" class="mx-4 space-y-3">
           <div v-for="(dir, i) in direccionesFiltradas" :key="i" class="p-4 bg-white rounded-xl shadow-sm">
              <div class="flex justify-between items-start">
                 <h4 class="font-bold text-gray-800">{{ dir.CTEDIR_CALLE }} {{ dir.CTEDIR_CALLENUMEXT }}</h4>
                 <v-chip size="x-small" color="blue">{{ dir.dia }}</v-chip>
              </div>
              <p class="text-xs text-gray-500 mt-1">{{ dir.CTEDIR_COLONIA }}, CP {{ dir.CTEDIR_CP }}</p>
           </div>
        </div>

        <div v-if="selectedTab === 'politica'" class="mx-4">
           <v-card class="rounded-xl pa-4 bg-white">
              <h3 class="font-bold text-gray-800 mb-2">Aviso de Privacidad</h3>
              <div class="text-sm text-gray-600 max-h-60 overflow-y-auto" v-html="privacyPolicy?.content"></div>
           </v-card>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { useUserStore } from "@/stores/userStore";
import { useTimeStore } from "@/stores/timestore";
import HistorialPedidosView from "@/components/HistorialPedidosView.vue";

export default {
  name: "PerfilRewards",
  components: { HistorialPedidosView },
  data() {
    return {
      timeStore: null,
      direcciones: [],
      selectedTab: "puntos",
      updatingPoints: false,
      timeInterval: null,
      tabs: [
        { name: "puntos", label: "Puntos", icon: "mdi-star-circle" },
        { name: "historial", label: "Historial", icon: "mdi-history" },
        { name: "politica", label: "Privacidad", icon: "mdi-file-document" },
        { name: "direcciones", label: "Direcciones", icon: "mdi-map-marker" },
      ],
      privacyPolicy: null,
    };
  },
  computed: {
    userStore() {
      return useUserStore();
    },
    user() {
      return this.userStore.user || {};
    },
    cliente() {
      return this.user;
    },
    direccionesFiltradas() {
      const fiscal = this.direcciones.find(d => d.CTEDIR_TIPOFIS == 1);
      const entregas = this.direcciones.filter(d => d.CTEDIR_TIPOFIS != 1);
      return fiscal ? [fiscal, ...entregas] : entregas;
    },
  },
  watch: {
    'user.cliente': {
      handler(nuevoCliente) {
        if (nuevoCliente) {
          if (this.user.direcciones && this.direcciones.length === 0) {
            this.direcciones = this.user.direcciones.map(d => ({ ...d, dia: d.dia || "Sin frecuencia" }));
          }
          this.obtenerNuevaData();
          this.obtenerDirecciones();
        }
      },
      immediate: true
    }
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
    },
    copyId() { 
      if (this.user?.id) navigator.clipboard.writeText(this.user.id); 
    },
    async obtenerNuevaData() {
      try {
        if (!this.user?.id) return;
        this.updatingPoints = true;
        const res = await api.get(`/get-mvcoins/${this.user.id}`);
        this.userStore.setUser({ ...this.user, ...res.data });
      } catch (err) { console.error(err); } finally { this.updatingPoints = false; }
    },
    async obtenerDirecciones() {
      try {
        if (!this.user?.cliente) return;
        const response = await api.get(`/find-direccion/${this.user.cliente}`);
        if (response.data && response.data.length > 0) {
          this.direcciones = response.data.map(d => ({ ...d, dia: d.dia || "Sin frecuencia" }));
        }
      } catch (error) { console.error(error); }
    },
    async cargarPolitica() {
      try {
        const res = await api.get("https://mvexpress.mx/api/privacy-policy");
        this.privacyPolicy = res.data;
      } catch (err) { console.error(err); }
    }
  },
  async mounted() {
    this.timeStore = useTimeStore();
    await this.timeStore.syncServerTime();
    this.timeInterval = setInterval(() => { this.timeStore.tick(); }, 1000);
    
    await this.cargarPolitica();
  }, // <-- Aquí estaba el error, faltaba cerrar el mounted()
  
  beforeUnmount() {
    if (this.timeInterval) clearInterval(this.timeInterval);
  }
};
</script>

<style scoped>
/* 1. Fondo Global */
.native-layout {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #2952da;
  overflow: hidden; /* Solo scroll en wrapper interno */
}

/* 2. Scroll Wrapper */
.scroll-wrapper {
  height: 100vh;
  width: 100%;
  overflow-y: auto; /* Scroll aquí */
  -webkit-overflow-scrolling: touch; /* Suavidad en iOS */
}

/* 3. Padding seguro para contenido */
.content-body {
  padding-top: calc(70px + env(safe-area-inset-top)); /* Espacio header */
  padding-bottom: calc(90px + env(safe-area-inset-bottom)); /* Espacio footer */
}

.fixed-header {
  position: fixed;
  top: 0; left: 0; right: 0; z-index: 50;
}
</style>